module.exports = __webpack_public_path__ + "img/about_logo_25.64c71963.png";